import { UserBaseScope } from 'mormaii-web-presentation/user-base'
import type { ViewFactory } from 'wdc-cube-solid'

import { UserBaseView } from './v-user-base'

export function registerViews(rv: typeof ViewFactory.register) {
    rv(UserBaseScope, UserBaseView)
}

export { UserBaseView }
